import { Nilable } from "@shared/utils";
import { MensajeProcesador } from "../MensajeProcesador";

export class NonFieldProcesador implements MensajeProcesador {
    puedeProcesar(mensaje: string): boolean {
        return mensaje.includes("non_field_errors");
    }

    procesar(mensaje: string): Nilable<string> {
        if (mensaje.includes("Unable to login with provided credentials.")) {
            return "Credenciales incorrectas";
        }

        return null;
    }
}
